<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="mb10">
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button> {{$route.query.company}}
    </a-card>
    <a-card>
      <a-form :label-col="{span:3}">
        <a-form-item label="允许外部码参与活动">
          <a-radio-group @change="onChangeRadio" v-model:value="formData.external_code_is_act">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="是否有外部码">
          <a-radio-group @change="onChangeRadio" v-model:value="formData.is_have_external">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="外部码查询模式" v-if="formData.is_have_external==1">
          <a-radio-group @change="onChangeRadio" v-model:value="formData.is_external_query">
            <a-radio value="1">外部</a-radio>
            <a-radio value="0">码库</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="查询批次" v-if="formData.is_have_external==1&&formData.is_external_query==0">
          <a-input v-model:value="formData.external_code_batch_sn" style="width:200px"></a-input>
        </a-form-item>
        <a-form-item label="允许工厂写入外部码" v-if="formData.is_have_external==1&&formData.is_external_query==0">
          <a-radio-group @change="onChangeRadio" v-model:value="formData.is_enable_factory_write">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="外部查询链接" v-if="formData.is_external_query==1">
          <a-input v-model:value="formData.external_query_config_url" style="width:200px"></a-input>
        </a-form-item>
        <a-form-item label="外部查询请求方式" v-if="formData.is_external_query==1">
          <a-radio-group @change="onChangeRadio" v-model:value="formData.external_query_config_method">
            <a-radio value="get">get</a-radio>
            <a-radio value="post">post</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="外部查询请求参数" v-if="formData.is_external_query==1">
          <!-- 数组 -->
          <a-input v-model:value="formData.external_query_config_params" placeholder="此数据用于post 提交" style="width:200px"></a-input>
        </a-form-item>
        <a-form-item label="外部查询码字段" v-if="formData.is_external_query==1">
          <a-input v-model:value="formData.external_query_config_code_field" style="width:200px"></a-input>
        </a-form-item>

      <a-form-item label="外部查询请求参数位置" v-if="formData.is_external_query==1">
          <a-select v-model:value="formData.external_query_config_params_position" style="width:200px">
            <a-select-option value="query">query</a-select-option>
            <a-select-option value="form-data">form-data</a-select-option>
            <a-select-option value="json">json</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="码字段位数" v-if="formData.is_external_query==1">
          <a-select v-model:value="formData.external_query_config_code_field_position" style="width:200px">
            <a-select-option value="query">query</a-select-option>
            <a-select-option value="form-data">form-data</a-select-option>
            <a-select-option value="json">json</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{offset:3}">
          <a-button type="primary" @click="onSubmit">保存</a-button>
        </a-form-item>
      </a-form>

    </a-card>
  </a-layout>
</template>


<script>
import { external_code, external_code_update } from "@/api/codeManage";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { LeftOutlined } from "@ant-design/icons-vue";
import { $iscode } from "../../../utils/app";
import { message } from "ant-design-vue";
import { isArray } from 'lodash';
export default {
  components: { LeftOutlined },
  name: "codePrefixDetail",
  props: {
    brandData: Object,
  },
  setup(props) {
    const formData = ref({
      is_have_external: 0,
      is_enable_factory_write: 0,
      is_external_query: 0,
      external_code_batch_sn: "",
      external_code_is_act: 0,
      external_query_config_url:'',
      external_query_config_method:"",
      external_query_config_params:[],
      external_query_config_code_field:"",
      external_query_config_code_field_position:""
    });
    const paramsValue=ref([{
      value:''
    }])
    const $route = inject("$route");
    const $router = inject("$router");
    const initData = async () => {
      let result = await external_code($route.query.brand_id)
        .then((res) => res.data)
        .catch((error) => error);
      console.log(result);
      formData.value = result.data;
    };
    const onSubmit = async () => {
      const hide = message.loading("正在加载中...", 0);

      // var par=paramsValue.value.map(v=>v.value)
      // formData.value.external_query_config_params=par
      let result = await external_code_update(
        $route.query.brand_id,
        formData.value
      )
        .then((res) => res.data)
        .catch((error) => error);
      setTimeout(hide);
      if ($iscode(result, true)) {
        $router.go(-1);
      }
    };
    onMounted(() => {
      initData();
    });
    const createParam=()=>{
     paramsValue.value.push({value:""})
    }
 
    return {
      formData,
      onSubmit,
      createParam,
      paramsValue
    };
  },
};
</script>